import { Injectable } from '@angular/core';
import { GraphqlService } from '@app/core/services/graphql.service';
import { languagesQuery } from '@app/pcs/settings/data/languages';

@Injectable()
export class LanguageDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  getLanguages() {
    return this.graphqlService.query(languagesQuery);
  }
}
